import type { JackpotWinner } from '@/types/winner'

const ROUND_ID_PATTERN = /^\d{4}-(0[1-9]|1[0-2])-jackpot$/
const FIELDS = ['roundId', 'label', 'winnerName', 'prizeName'] as const

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

/** 어느 검사에서 걸렸는지 — Sentry 진단용. 값 자체는 담지 않는다. 통과면 null */
export function explainInvalidJackpotWinner(value: unknown): string | null {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return '객체 아님'

  const record = value as Record<string, unknown>
  const missing = FIELDS.find((key) => !isNonEmptyString(record[key]))
  if (missing) return `${missing} 누락/빈 값`
  if (!ROUND_ID_PATTERN.test(record.roundId as string)) return 'roundId 형식'

  return null
}

/** winner.json 을 믿지 않고 검사한다. 앱이 쓰는 4필드만 꺼내고, 하나라도 어긋나면 null. */
export function validateJackpotWinner(value: unknown): JackpotWinner | null {
  if (explainInvalidJackpotWinner(value)) return null

  const record = value as Record<string, unknown>

  return {
    roundId: record.roundId as string,
    label: record.label as string,
    winnerName: record.winnerName as string,
    prizeName: record.prizeName as string,
  }
}
